import styled from 'styled-components';

import { styledLayout } from '@pkg/primitives';

import { tokens } from '../../tokens';

interface StyledSegmentProps {
    $minWidthTicks?: boolean;
}

// 'fullWidthFix' is needed to help keep the <Milestone />
// from breaking the layout when there are too many ticks.
export const StyledSegment = styled.div<StyledSegmentProps>`
    ${styledLayout.fullWidthFix};
    --yat_ticks-meter-tick-min-width: ${({ $minWidthTicks }) =>
        $minWidthTicks ? `${tokens.tick.minWidth}px` : undefined};

    position: relative;
    display: flex;
`;
